color-checkboxes
  .checkboxes(class="{ props.type } { props.mobile ? 'sp' : 'pc' }")
    template(each="{(colorMaster, index) in state.colorMasters}")
      label(class="{ colorMaster.color }")
        template(if="{ props.type === 'in_modal' }")
          img(src="{checkboxOnIcon}" class="checkbox-icon { state.colors.includes(colorMaster.color) ? '' : 'hidden' }")
          img(src="{checkboxOffIcon}" class="checkbox-icon { state.colors.includes(colorMaster.color) ? 'hidden' : '' }")
        input(type="checkbox" onchange="{didChangeColor}" name="cl[{index}]" value="{ colorMaster.color }"
              checked="{ state.existColor.includes(colorMaster.color) }")
        img(src="{colorMaster.icon}" class="color-icon" if="{ !!colorMaster.icon }")
        span(class!="{ colorMaster.text.length > 1 ? 'thin' : '' }")
          | { colorMaster.text }
  style(type="scss").
    .checkboxes {
      display: flex;
      flex-wrap: wrap;
      label {
        display: flex;
        align-items: center;
        input {
          margin-right: 5px;
        }
        img {
          margin-right: 2px;
        }
      }
      &.in_sidebar{
        margin-top: 10px;
        border-top: 2px solid #e8e8e8;
        border-bottom: 1px solid #e8e8e8;
        label {
          border-top: 1px solid #e8e8e8;
          border-bottom: 2px solid #e8e8e8;
          border-left: 1px solid #e8e8e8;
          padding: 12px 7px;
          width: calc(100% / 3);
          &:nth-child(3n+1) {
            border-left: 0;
          }
          span,a {
            font-size: 12px;
            &.thin {
              transform: scaleX(0.5);
              white-space: nowrap;
              width: 1em;
            }
          }
        }
        &.pc {
          label {
            .color-icon {
              height: 15px;
              width: 15px;
            }
            a {
              font-size: 12px;
              &:hover {
                text-decoration: underline;
              }
            }
          }
        }
        &.sp {
          margin-top: 16px;
          border-bottom: 0;
          label {
            border-top: 0;
            border-left-width: 2px;
            font-size: 15px;
            .color-icon {
              height: 13px;
              width: 13px;
            }
            span,a {
              font-size: 15px;
              &.thin {
                transform: none;
                letter-spacing: -1.5px;
              }
            }
          }
        }
      }
      &.in_modal {
        row-gap: 11.25vw;
        margin-right: -5.625vw;
        width: calc(100% + 5.625vw);
        label {
          width: calc(100% / 3);
          color: #6c6c6c;
          font-size: 4.6875vw;
          font-weight: 700;
          display: flex;
          align-items: center;
          input {
            display: none;
          }
          .checkbox-icon {
            height: 6.40625vw;
            width: 6.40625vw;
            margin-right: 1.25vw;
            &.hidden {
              display: none;
            }
          }
          .color-icon {
            height: 5.9375vw;
            width: 5.9375vw;
            margin-right: 1.25vw;
          }
        }
      }
    }
  script.
    import checkboxOnIcon from 'tags/smartsearch/checkbox_t.png'
    import checkboxOffIcon from 'tags/smartsearch/checkbox_f.png'
    import SmartsearchMaster from 'models/smartsearch-master.js'

    export default {
      checkboxOnIcon,
      checkboxOffIcon,
      onBeforeMount(props, state) {
        const masterData = new SmartsearchMaster()
        state.colorMasters = masterData.colorMasters
        state.colorValues = state.colorMasters.map(current => current.color)

        state.existColor = []
        state.colors = []
      },
      didChangeColor() {
        const colorElements = this.root.querySelectorAll('.checkboxes input')
        const colors = Array.prototype.map.call(colorElements, (c) => {
          return c.checked ? c.value : ''
        }).filter(color => color.length > 0)
        const colorQuery = colors.join(',')
        this.update({
          colorQuery,
          colors
        })
        this.props.onUpdate(colorQuery)
        this.props.observable.trigger('onUpdateColorQuery', this.colorQuery)
      },
      initializeByExistQuery() {
        const result = (new RegExp('[?&]'+encodeURIComponent('cl')+'=([^&]*)')).exec(location.search)
        if(!result) return

        const existColor = decodeURIComponent(result[1]).split(',')
        this.update({
          existColor,
          colors: existColor
        })
      },
      urlFromValueWithFormData(value) {
        const queryKey = 'cl'
        if (!this.props.formdata) return

        const formDataObj = Object.fromEntries(Array.from(this.props.formdata.entries()))

        const currentValues = (this.state.colorQuery || '').split(',')
        if (!currentValues.includes(value)) {
          const values = Array.from(this.state.colorValues).filter( v => (currentValues.includes(v) || value == v) )
          formDataObj[queryKey] = values.join(',')
        }
        const formDataArray = Array.from(Object.entries(formDataObj)).sort( (kv1, kv2) => {
          if (kv1 < kv2) { return -1 }
          else if (kv1 > kv2) { return 1 }
          else return 0
        })
        const url = '/watches/?' + formDataArray.filter( kv => !!kv[1] ).map( kv => kv[0] + '=' + kv[1] ).join('&')
        return url
      },
      onMounted(props, state) {
        this.initializeByExistQuery()
        this.update()
      },
    }
